/** Procurement stage identities are app projections, not FLARE execution modes. */
export const REQUIREMENT_INTAKE_MODE_KEY = 'requirement_intake';
export const ANALYSIS_MODE_KEY = 'analysis_mode';
export const SOURCING_MODE_KEY = 'intelligent_sourcing';
export const normalizeCoreModeKey = (value) => String(value ?? '').trim();
